export const normalizeRegion = (region: string) => {
  if (['sicily', 'sicilia', 'sizilien', 'sicile'].includes(region)) {
    return 'sicily';
  } else if (['puglia', 'apulien', 'pouilles'].includes(region)) {
    return 'puglia';
  }
  return undefined;
};
